module.exports = __webpack_public_path__ + "static/img/bannerText3.30192a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bannerText3.png
// module id = GyeD
// module chunks = 1